import { useSelector } from 'react-redux';
import { RootState } from 'store';

export function usePermission(permission: string): boolean {
  const perms = useSelector(
    (state: RootState) => state.user?.permissions ?? []
  );

  return perms.includes(permission);
}
